<template>
    <v-combobox
        v-model="select"
        :items="items"
        :search-input.sync="search"
        class="search-panorama-query-combo"
        dark
        label="Numéro de brochure et IDCC"
        hide-selected
        append-icon=""
        :item-value="item => item.subtype + item.suggestion + item.label"
        no-filter
        solo-inverted
        return-object
        :multiple="true"
        @input="search = null"
        @change="cleanTextSearch"
        :hint="showMaxHint ? `Maximum de 5 sélections` : null"
        :persistent-hint="showMaxHint"
        :disabled="loading"
    >
        <template slot="selection" slot-scope="data">
            <div class="selected-container">
                <search-suggest-item :item="data.item" />
                <v-icon color="black" class="reset" @click="removeItem(data.item)">
                    mdi-close-circle
                </v-icon>
            </div>
        </template>
        <template slot="item" slot-scope="data">
            <search-suggest-item :item="data.item" />
        </template>
        <template slot="no-data">
            <p class="no-result-text" v-if="search && search.length >= 2">
                Aucune convention collective ne correspond à votre recherche
            </p>
        </template>
    </v-combobox>
</template>

<script>
import SearchSuggestItem from "./SearchSuggestItem.vue";
import { Services } from "src/services/Services";
import { isString, difference, isEmpty, isArray } from "lodash";

export default {
    props: ["value", "loading"],
    components: { SearchSuggestItem },
    data() {
        return {
            select: null,
            search: null,
            items: [],
        };
    },
    async mounted() {
        this.select = this.value;
        await Services.search.waitConventionsEngineInit();
    },
    computed: {
        showMaxHint() {
            return isArray(this.select) && this.select.length >= 5;
        },
    },
    methods: {
        removeItem(item) {
            this.select = this.select.filter(
                selection =>
                    !(
                        selection.suggestion === item.suggestion &&
                        selection.subtype === item.subtype
                    )
            );
        },
        cleanTextSearch(items) {
            this.select = items.filter(item => !isString(item));
        },
    },
    watch: {
        value() {
            this.select = this.value;
        },
        search(value) {
            if (!value || (this.select && this.select.length >= 5)) {
                this.items = [];
                return;
            }
            this.items = Services.search.getPanoramaSuggestions(value);
        },
        async select(newValue, oldValue) {
            const addedValues = difference(newValue, oldValue);
            const removedValues = difference(oldValue, newValue);
            if (!isEmpty(addedValues) || !isEmpty(removedValues)) this.$emit("input", newValue);
        },
    },
};
</script>

<style lang="sass" scoped>
.search-panorama-query-combo
    &.theme--dark.v-text-field--solo-inverted
        border-radius: 0
        ::v-deep
            & > .v-input__control > .v-input__slot
                background: #F2F2F2

            .v-label
                color: $color-text

            input
                caret-color: $color-text

            .v-select__selection--comma,
            .v-select__selections
                color: $color-text
    ::v-deep
        .theme--dark.v-messages
            color: $color-text

.selected-container
    background: white
    height: 32px
    display: flex
    align-items: center
    padding: 0 10px
    margin: 5px

.no-result-text
    padding: 16px 0 0 16px
</style>
